"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT = void 0;
exports.TEXT = {
    alias: 'TEXTO',
    description: 'Converte um número, data ou data e hora em texto de acordo com um formato especificado.',
    arg_names: ['texto_a_ser_transformado', 'formato', 'idioma'],
    args_description: [
        'texto que será transformado',
        'formato do texto - Exemplos: : HH:mm; hh:mm; hh:mm:ss; R$#,###.00; $0.00; 0%; 0.0%; #.#%; mmmm-dd-yyyy, hh:mm A/P; mm/dd,yyyy; #,###; 0.00; #.##',
        'idioma a ser usado',
    ],
};
